import React, { useState, useEffect } from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';

const AgeVerification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setIsVisible(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-dark-bg/95 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-dark-card border border-dark-border rounded-xl shadow-2xl p-8 max-w-md w-full animate-fade-in">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-dark-accent/20 rounded-full mb-4">
            <AlertCircle className="text-dark-accent w-8 h-8" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">
            Vérification d'Âge
          </h2>
          <p className="text-dark-muted">
            Vous devez avoir au moins 18 ans pour accéder à ce site
          </p>
        </div>

        <div className="flex flex-col space-y-3">
          <button
            onClick={handleConfirm}
            className="w-full px-6 py-3 bg-dark-accent hover:bg-dark-accentHover text-white rounded-lg transition-colors font-semibold flex items-center justify-center space-x-2"
          >
            <CheckCircle className="w-5 h-5" />
            <span>Oui, j'ai 18+ ans</span>
          </button>
          <button
            onClick={handleDecline}
            className="w-full px-6 py-3 bg-dark-surface hover:bg-dark-border text-white rounded-lg transition-colors font-semibold border border-dark-border"
          >
            Non, je suis mineur
          </button>
        </div>

        <p className="text-xs text-dark-muted text-center mt-6">
          En continuant, vous confirmez que vous avez plus de 18 ans et acceptez nos{' '}
          <a
            href="/conditions-generales"
            className="text-dark-accent hover:underline"
          >
            Conditions Générales
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;
